import { useState } from 'react';
import { Link } from 'react-router-dom';
import MotionScene from './MotionScene';

const base = import.meta.env.BASE_URL;

type Tool = { name: string; src: string };

const BUSINESS: Tool[] = [
  { name: 'WhatsApp', src: `${base}logos/whatsapp.svg` },
  { name: 'Gmail', src: `${base}logos/gmail.svg` },
  { name: 'Google Sheets', src: `${base}logos/googlesheets.svg` },
  { name: 'Google Calendar', src: `${base}logos/googlecalendar.svg` },
  { name: 'Slack', src: `${base}logos/slack.svg` },
  { name: 'HubSpot', src: `${base}logos/hubspot.svg` },
  { name: 'Notion', src: `${base}logos/notion.svg` },
  { name: 'Xero', src: `${base}logos/xero.svg` },
  { name: 'Stripe', src: `${base}logos/stripe.svg` },
  { name: 'Airtable', src: `${base}logos/airtable.svg` },
];

const AUTOMATION: Tool[] = [
  { name: 'n8n', src: `${base}logos/n8n-logo.png` },
  { name: 'Make', src: `${base}logos/make-logo.png` },
  { name: 'Zapier', src: `${base}logos/zapier-logo.png` },
];

const ToolsStrip = () => {
  const [paused, setPaused] = useState(false);
  return (
    <section className="qi-tools" aria-label="Tools we work with">
      <div className="qi-tools-inner">
        <div className="tools-heading"><div><p className="studio-eyebrow">Tools your team uses</p><h2 className="qi-tools-title">We work with what you already have.</h2></div>
        <p className="qi-tools-lead">Start with the systems your team already uses. We check integration options, access and plan limits before recommending how to connect them.</p></div>
        <div className="tools-ribbon-controls"><button type="button" className="motion-toggle" aria-pressed={paused} onClick={() => setPaused(!paused)}><span aria-hidden="true">{paused ? '▷' : 'Ⅱ'}</span> {paused ? 'Play tool strip' : 'Pause tool strip'}</button></div>
      </div>
      <MotionScene className="tools-ribbon" paused={paused} label="Explore the business tools">
        <div className="tools-track">{[false, true].map(duplicate => <ul key={String(duplicate)} aria-label={duplicate ? undefined : 'Business tools'} aria-hidden={duplicate || undefined}>{BUSINESS.map(tool => <li key={tool.name} className="qi-logo-cell"><img src={tool.src} alt="" width={34} height={34} loading="lazy" /><span>{tool.name}</span></li>)}</ul>)}</div>
      </MotionScene>
      <div className="qi-tools-inner tools-footnote">
        <p className="qi-tools-secondary">Tools shown are examples, not partnerships or endorsements. Connections depend on the available APIs and account permissions.</p>
        <div className="tools-platforms"><span>Connected with</span><ul className="qi-logo-row" aria-label="Automation platforms">{AUTOMATION.map(tool => <li key={tool.name} className="qi-logo-cell-sm"><img src={tool.src} alt="" width={22} height={22} loading="lazy" /><span>{tool.name}</span></li>)}</ul></div>
      </div>
      <aside className="qi-invite">
        <img className="qi-invite-photo" src={`${base}photos/pexels-8374279.jpg`} alt="" aria-hidden="true" loading="lazy" />
        <div className="qi-invite-copy"><h3>Show us where the work gets stuck.</h3><p>Describe the task and the tools you use. We can work out what a first version needs to do.</p><Link className="qi-invite-link" to="/#request-demo">Request a demo ↗</Link></div>
      </aside>
    </section>
  );
};
export default ToolsStrip;
